import {ActionStatusModuleConfiguration} from "./action_status.module.configuration";
import {ActionStatusComponent} from "./component/action_status.component/action_status.component";

ActionStatusModuleConfiguration.createNewModule()
    .component('actionStatus', ActionStatusComponent.instance);